export const ServiceTypesSettingsTrackingIds = {
  // Event Tracking IDs
  events: {
    servicesPageViewed: 'services-settings-page-viewed',
    addServiceToAppointmentTypeClicked: 'add-service-to-appointment-type-clicked', // For integrated
    newServiceClicked: 'new-service-clicked', // For core
    serviceSaveClicked: 'service-save-clicked',
    serviceEditClicked: 'service-edit-clicked',
    serviceDeleteClicked: 'service-delete-clicked',
  },
} as const;
